import { Region } from '@/api/apis/resources/schedule';
import { CSAtHubFormSection } from '../sections';

type CSSchedulerSettingsAtHubInputsFormProps = {
  isReadOnly: boolean;
  regions: Region[];
};

export const CSSchedulerSettingsAtHubInputsForm = ({
  regions,
  isReadOnly,
}: CSSchedulerSettingsAtHubInputsFormProps) => {
  return (
    <div className="flex mb-5">
      <CSAtHubFormSection isReadOnly={isReadOnly} regions={regions} />
    </div>
  );
};
